module.exports = __webpack_public_path__ + "img/Group 197.4b7a5d01.png";